/**
 * FikoCivata — Metrik Cıvata/Diş Standardı + Tork
 * Diş tablosu (adım, kılavuz/tap matkap, geçme deliği) + sıkma torku (T = K·D·F).
 */

export interface DisOlcu {
  ad: string;       // M6 vb.
  cap: number;      // nominal çap (mm)
  adim: number;     // kaba adım (mm)
  tapDrill: number; // kılavuz matkap çapı (mm)
  gecmeDelik: number; // serbest geçme deliği (mm)
  gerilmeAlani: number; // diş gerilme kesit alanı As (mm²) — tork için
}

export const DIS_TABLOSU: DisOlcu[] = [
  { ad: 'M3',  cap: 3,  adim: 0.5,  tapDrill: 2.5,  gecmeDelik: 3.4,  gerilmeAlani: 5.03 },
  { ad: 'M4',  cap: 4,  adim: 0.7,  tapDrill: 3.3,  gecmeDelik: 4.5,  gerilmeAlani: 8.78 },
  { ad: 'M5',  cap: 5,  adim: 0.8,  tapDrill: 4.2,  gecmeDelik: 5.5,  gerilmeAlani: 14.2 },
  { ad: 'M6',  cap: 6,  adim: 1.0,  tapDrill: 5.0,  gecmeDelik: 6.6,  gerilmeAlani: 20.1 },
  { ad: 'M8',  cap: 8,  adim: 1.25, tapDrill: 6.8,  gecmeDelik: 9.0,  gerilmeAlani: 36.6 },
  { ad: 'M10', cap: 10, adim: 1.5,  tapDrill: 8.5,  gecmeDelik: 11.0, gerilmeAlani: 58.0 },
  { ad: 'M12', cap: 12, adim: 1.75, tapDrill: 10.2, gecmeDelik: 13.5, gerilmeAlani: 84.3 },
  { ad: 'M14', cap: 14, adim: 2.0,  tapDrill: 12.0, gecmeDelik: 15.5, gerilmeAlani: 115 },
  { ad: 'M16', cap: 16, adim: 2.0,  tapDrill: 14.0, gecmeDelik: 17.5, gerilmeAlani: 157 },
  { ad: 'M20', cap: 20, adim: 2.5,  tapDrill: 17.5, gecmeDelik: 22.0, gerilmeAlani: 245 },
  { ad: 'M24', cap: 24, adim: 3.0,  tapDrill: 21.0, gecmeDelik: 26.0, gerilmeAlani: 353 },
  { ad: 'M30', cap: 30, adim: 3.5,  tapDrill: 26.5, gecmeDelik: 33.0, gerilmeAlani: 561 },
];

/** Kalite sınıfı → akma gerilmesi yaklaşık (MPa). */
export const CIVATA_SINIF: Record<string, number> = { '8.8': 640, '10.9': 940, '12.9': 1100 };

export interface TorkSonuc { onYukN: number; torkNm: number; }

/**
 * Sıkma torku: ön yük F = 0.7·As·akma (emniyetli); T = K·D·F.
 * K = sürtünme faktörü (~0.2 yağsız çelik). D nominal çap (m).
 */
export function torkHesapla(olcu: DisOlcu, sinif: string, kFaktor: number, yuzdeYuk: number): TorkSonuc {
  const akma = CIVATA_SINIF[sinif] ?? 640;
  const onYukN = (yuzdeYuk / 100) * olcu.gerilmeAlani * akma;   // N (As mm² × MPa = N)
  const torkNm = kFaktor * (olcu.cap / 1000) * onYukN;          // N·m
  return { onYukN, torkNm };
}
